module.exports = `:root {
  --primitiveColorPrimary610: #d57e02;
  --primitiveColorPrimary740: #ff9c00;
  --primitiveColorPrimary760: #ffa600;
  --primitiveColorSecondary220: #134067;
  --primitiveColorSecondary260: #094f90;
  --primitiveColorSecondary490: #297ac6;
  --primitiveColorSecondary810: #afccec;
  --primitiveColorSecondary960: #edf5f3;
  --primitiveColorTertiary710: #40c1ba;
  --primitiveColorQuarternary320: #61398b;
  --primitiveColorQuinary550: #de5346;
  --primitiveColorMono0: #000000;
  --primitiveColorMono170: #2a2b29;
  --primitiveColorMono290: #444642;
  --primitiveColorMono470: #707070;
  --primitiveColorMono740: #b6b6b6;
  --primitiveColorMono820: #cccccc;
  --primitiveColorMono940: #eeeeee;
  --primitiveColorMono970: #f8f5f5;
  --primitiveColorMono1000: #ffffff;
  --primitiveColorSuccess670: #88b04b;
  --primitiveColorInfo490: #297ac6;
  --primitiveColorError340: #a00048;
  --primitiveColorWarning570: #fa4300;
  --primitiveTypographyFontFamily: 'Proxima Nova', Helvetica, Arial;
  --primitiveTypographyTypescaleDesktop1: 3.5rem;
  --primitiveTypographyTypescaleDesktop2: 2.375rem;
  --primitiveTypographyTypescaleDesktop3: 1.875rem;
  --primitiveTypographyTypescaleDesktop4: 1.25rem;
  --primitiveTypographyTypescaleDesktop5: 1.125rem;
  --primitiveTypographyTypescaleDesktop6: 1rem;
  --primitiveTypographyTypescaleDesktop7: 0.875rem;
  --primitiveTypographyTypescaleMobile1: 2.1rem;
  --primitiveTypographyTypescaleMobile2: 1.6625rem;
  --primitiveTypographyTypescaleMobile3: 1.5rem;
  --primitiveTypographyTypescaleMobile4: 1.125rem;
  --primitiveTypographyTypescaleMobile5: 1rem;
  --primitiveTypographyTypescaleMobile6: 0.875rem;
}
`;